window.jQuery = window.$ = require('jquery');

class JSSpinner {
    static _spinner = null;
    static _target = null;
    static _className = 'veil custom_loader custom_loader_overlay';
  
    static show(selector = 'body') {
      const target = typeof selector === 'string'
        ? document.querySelector(selector)
        : selector;
  
      if (!(target instanceof HTMLElement)) {
        throw new Error('JSSpinner: selector must be a valid DOM element or selector string');
      }
  
      if (target.querySelector(`.${this._className.split(' ').join('.')}`)) return;
  
      const computedStyle = getComputedStyle(target);
      if (computedStyle.position === 'static') {
        target.style.position = 'relative';
      }
  
      const wrapper = document.createElement('div');
      wrapper.className = this._className;
      wrapper.style.display = 'flex';

      Object.assign(wrapper.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      });
  
      wrapper.innerHTML = `
        <div class="underlay" style="position: absolute;">
          <div class="spinner">
            <div class="dot1"></div>
            <div class="dot2"></div>
          </div>
        </div>
      `;
  
      target.appendChild(wrapper);
      this._spinner = wrapper;
      this._target = target;
  
      target.dispatchEvent(new CustomEvent('jsspinner:show', { detail: { target } }));
    }
  
    static hide() {
      if (this._spinner && this._target) {
        this._spinner.remove();
        this._target.dispatchEvent(new CustomEvent('jsspinner:hide', { detail: { target: this._target } }));
        this._spinner = null;
        this._target = null;
      }
    }
  }
  
  (function ($) {
    $.fn.jsspinner = function () {
      const elements = this;
  
      return {
        start() {
          elements.each(function () {
            JSSpinner.show(this);
          });
          return this;
        },
        stop() {
          elements.each(function () {
            const spinner = this.querySelector(`.${JSSpinner._className.split(' ').join('.')}`);
            if (spinner) {
              spinner.remove();
              this.dispatchEvent(new CustomEvent('jsspinner:hide', {
                detail: { target: this }
              }));
            }
          });
          return this;
        }
      };
    };
  })(window.jQuery);
  

  window.JSSpinner = JSSpinner;
  
  module.exports = function () {
    
  };
  